import "./Research.css";

function Research() {
  return (
    <main id="top" className="content-inner">
        <section id="research" className="research-section">
        <div className="research-intro">
            <div>
            <h2>
                Open by construction<span style={{ color: "#EF3A5D" }}>.</span> Including what didn't work<span style={{ color: "#EF3A5D" }}>.</span>
            </h2>
            </div>

            <div>
            <p>
                The method behind the index is published in full in the EPU Index 
                Poland Working Paper Series (No. 01/2026), with the data on OSF (osf.io/ep759) — the newspapers, 
                the dictionary, the human audit, the statistical tests, and the results that came out against 
                what we expected. Professor Steven J. Davis, who co-created the method, discussed and commented 
                on its construction and validation for Poland.
            </p>

            <a href="research.html">
                Read the working paper →
            </a>
            </div>
        </div>
        </section>
    </main>
  );
}

export default Research;